import React from 'react';
import { Button, CUIText, Icon, IconNames, LoadingIndicator } from '@dotcom/crown-ui';
import { ImageResponse } from '../../../../global-types/images';
import { PhotosUploadedProps } from '../photo-drawer-types';
import styles from '../photo-drawer.module.scss';
import { PhotoImage } from './photo-image';

export const PhotosUploaded = ({
  onUploadImages,
  onDeleteImages,
  photoTrayImages,
  labels,
  selectedPhotos,
  setSelectedPhotos,
  isDeleting,
  setIsDeleting,
  onCancelDelete,
  onPhotoSelect,
  isUploading,
  footerContent,
  isFooterSticky = false,
}: PhotosUploadedProps): React.ReactElement => {
  const onSelectPhoto = (photo: ImageResponse, e: React.MouseEvent) => {
    e.stopPropagation();
    if (isDeleting) {
      const isPhotoSelected = selectedPhotos.some((p) => p.photo_tray_image_id === photo.photo_tray_image_id);
      if (isPhotoSelected) {
        // If photo is already selected, deselect it (remove it from array)
        setSelectedPhotos(selectedPhotos.filter((p) => p.photo_tray_image_id !== photo.photo_tray_image_id));
      } else {
        setSelectedPhotos([...selectedPhotos, photo]);
      }
    }

    if (onPhotoSelect && !isDeleting) {
      onPhotoSelect(photo);
    }
  };

  return (
    <div className={styles['photos-uploaded-container']}>
      <div className={styles['photos-uploaded-list']}>
        {photoTrayImages && (
          <Button
            testId="photo-upload-button"
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onUploadImages();
            }}
            className={styles['photo-upload-button']}
          >
            <Icon
              className={styles['photo-lot-icon']}
              name={IconNames.PhotoslotBold}
              altText="photo upload"
              size="24"
            />
            <CUIText className={styles['no-photos-uploaded-title']} as="span" color="textSecondary">
              {labels.uploadPhoto}
            </CUIText>
          </Button>
        )}
        {photoTrayImages.map((photo) => (
          <PhotoImage
            isDeleting={isDeleting}
            key={photo.photo_tray_image_id}
            photo={photo}
            isSelected={selectedPhotos.some((p) => p.photo_tray_image_id === photo.photo_tray_image_id)}
            onSelect={(photo, e) => onSelectPhoto(photo, e)}
            onDelete={(photo, e) => onDeleteImages([photo], e)}
          />
        ))}
        {isUploading && <LoadingIndicator isCenteredInParent={true} parentHeight="120px" />}
        {footerContent && <div>{footerContent}</div>}
      </div>
      {/* Delete button intentionally removed — image deletion is handled
          via the per-image quick-delete icon in PhotoImage. */}
    </div>
  );
};
